import { marked } from 'marked';
import DOMPurify from 'dompurify';
import { IntlShape } from 'react-intl';

/**
 * Converts a translation message to sanitized HTML from markdown
 * @param intl - The IntlShape object from react-intl
 * @param messageId - The translation message id
 * @param values - Optional values for interpolation
 * @returns Object with __html property containing sanitized HTML
 */
export const getMarkdownFromTranslation = (
  intl: IntlShape,
  messageId: string,
  values?: Record<string, string | number>,
): { __html: string } => {
  const content = intl.formatMessage({ id: messageId }, values);
  const sanitizedHtml = DOMPurify.sanitize(marked.parse(content) as string);
  return { __html: sanitizedHtml };
};
